import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const RefundPolicyContent = ({ showHeroCards = true }) => {
    return (
        <div>
            {/* Quick Overview Cards - Optional for dashboard version */}
            {showHeroCards && (
                <div className="grid mb-6">
                    <div className="col-12 md:col-4">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                                 }}>
                                <i className="pi pi-times-circle text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">Cancel Anytime</h4>
                            <p className="text-600 m-0">Flexibility to cancel from Billing Portal</p>
                        </Card>
                    </div>
                    
                    <div className="col-12 md:col-4">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                                 }}>
                                <i className="pi pi-clock text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">24 Hour Window</h4>
                            <p className="text-600 m-0">Request refunds within 24 hours</p>
                        </Card>
                    </div>
                    
                    <div className="col-12 md:col-4">
                        <Card className="h-full text-center shadow-4 border-round-xl hover:shadow-8 transition-all transition-duration-300">
                            <div className="inline-flex align-items-center justify-content-center mb-3" 
                                 style={{
                                     width: '60px',
                                     height: '60px',
                                     borderRadius: '12px',
                                     background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                                 }}>
                                <i className="pi pi-wallet text-white text-2xl"></i>
                            </div>
                            <h4 className="font-bold mb-2">5-7 Days</h4>
                            <p className="text-600 m-0">Refund processing timeline</p>
                        </Card>
                    </div>
                </div>
            )}

            {/* Policy Sections */}
            <div className="grid">
                <div className="col-12">
                    {/* Section 1: Subscription Plans */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-green-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-calendar text-green-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">1. Subscription Plans</h2>
                        </div>
                        
                        <div className="grid">
                            <div className="col-12 lg:col-4">
                                <div className="surface-50 border-round-lg p-4 h-full text-center">
                                    <div className="bg-green-100 inline-flex align-items-center justify-content-center border-circle mb-3" 
                                         style={{ width: '60px', height: '60px' }}>
                                        <i className="pi pi-check text-green-600 text-2xl"></i>
                                    </div>
                                    <h4 className="font-bold mb-2">Cancel Anytime</h4>
                                    <p className="text-700 m-0">
                                        Cancel directly from your Billing Portal
                                    </p>
                                </div>
                            </div>
                            
                            <div className="col-12 lg:col-4">
                                <div className="surface-50 border-round-lg p-4 h-full text-center">
                                    <div className="bg-blue-100 inline-flex align-items-center justify-content-center border-circle mb-3" 
                                         style={{ width: '60px', height: '60px' }}>
                                        <i className="pi pi-calendar-plus text-blue-600 text-2xl"></i>
                                    </div>
                                    <h4 className="font-bold mb-2">Continued Access</h4>
                                    <p className="text-700 m-0">
                                        Access continues until end of paid billing cycle
                                    </p>
                                </div>
                            </div>
                            
                            <div className="col-12 lg:col-4">
                                <div className="surface-50 border-round-lg p-4 h-full text-center">
                                    <div className="bg-orange-100 inline-flex align-items-center justify-content-center border-circle mb-3" 
                                         style={{ width: '60px', height: '60px' }}>
                                        <i className="pi pi-info-circle text-orange-600 text-2xl"></i>
                                    </div>
                                    <h4 className="font-bold mb-2">Important Note</h4>
                                    <p className="text-700 font-italic m-0">
                                        "No pro-rated or partial-period refunds"
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 2: API Usage Top-Ups */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-purple-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-database text-purple-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">2. API Usage Top-Ups</h2>
                        </div>
                        
                        <div className="bg-red-50 border-round-lg p-4">
                            <div className="grid">
                                <div className="col-12 md:col-6">
                                    <div className="flex align-items-start">
                                        <i className="pi pi-exclamation-triangle text-orange-500 text-xl mr-3 mt-1"></i>
                                        <div>
                                            <h4 className="font-bold mb-2">Non-Refundable Credits</h4>
                                            <p className="text-700 m-0">
                                                "Pre-paid API credits are non-refundable once consumed"
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Section 3: Payment Failures & Retries */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-blue-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-credit-card text-blue-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">3. Payment Failures & Automatic Retries</h2>
                        </div>
                        
                        <div className="surface-50 border-round-lg p-3 md:p-4">
                            {/* Mobile vertical layout */}
                            <div className="block md:hidden">
                                <div className="flex flex-column gap-3">
                                    <div className="flex align-items-center">
                                        <div className="bg-primary inline-flex align-items-center justify-content-center border-circle text-white font-bold mr-3" 
                                             style={{ width: '32px', height: '32px', fontSize: '14px' }}>1</div>
                                        <span className="text-700 font-semibold">Payment Fails</span>
                                    </div>
                                    <div className="ml-4">
                                        <i className="pi pi-arrow-down text-primary"></i>
                                    </div>
                                    <div className="flex align-items-center">
                                        <div className="bg-orange-500 inline-flex align-items-center justify-content-center border-circle text-white font-bold mr-3" 
                                             style={{ width: '32px', height: '32px', fontSize: '14px' }}>2</div>
                                        <span className="text-700 font-semibold">3 Retries in 7 Days</span>
                                    </div>
                                    <div className="ml-4">
                                        <i className="pi pi-arrow-down text-primary"></i>
                                    </div>
                                    <div className="flex align-items-center">
                                        <div className="bg-red-500 inline-flex align-items-center justify-content-center border-circle text-white font-bold mr-3" 
                                             style={{ width: '32px', height: '32px', fontSize: '14px' }}>3</div>
                                        <span className="text-700 font-semibold">Subscription Paused</span>
                                    </div>
                                    <div className="ml-4">
                                        <i className="pi pi-arrow-down text-primary"></i>
                                    </div>
                                    <div className="flex align-items-center">
                                        <div className="bg-green-500 inline-flex align-items-center justify-content-center border-circle text-white font-bold mr-3" 
                                             style={{ width: '32px', height: '32px', fontSize: '14px' }}>4</div>
                                        <span className="text-700 font-semibold">Pay & Resume</span>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Desktop horizontal layout */}
                            <div className="hidden md:flex align-items-center justify-content-center mb-4">
                                <div className="flex align-items-center">
                                    {/* Step 1 */}
                                    <div className="text-center">
                                        <div className="bg-primary inline-flex align-items-center justify-content-center border-circle text-white font-bold mb-2" 
                                             style={{ width: '40px', height: '40px' }}>1</div>
                                        <p className="text-700 font-semibold m-0">Payment Fails</p>
                                    </div>
                                    
                                    <i className="pi pi-arrow-right text-primary mx-4"></i>
                                    
                                    {/* Step 2 */}
                                    <div className="text-center">
                                        <div className="bg-orange-500 inline-flex align-items-center justify-content-center border-circle text-white font-bold mb-2" 
                                             style={{ width: '40px', height: '40px' }}>2</div>
                                        <p className="text-700 font-semibold m-0">3 Retries in 7 Days</p>
                                    </div>
                                    
                                    <i className="pi pi-arrow-right text-primary mx-4"></i>
                                    
                                    {/* Step 3 */}
                                    <div className="text-center">
                                        <div className="bg-red-500 inline-flex align-items-center justify-content-center border-circle text-white font-bold mb-2" 
                                             style={{ width: '40px', height: '40px' }}>3</div>
                                        <p className="text-700 font-semibold m-0">Subscription Paused</p>
                                    </div>
                                    
                                    <i className="pi pi-arrow-right text-primary mx-4"></i>
                                    
                                    {/* Step 4 */}
                                    <div className="text-center">
                                        <div className="bg-green-500 inline-flex align-items-center justify-content-center border-circle text-white font-bold mb-2" 
                                             style={{ width: '40px', height: '40px' }}>4</div>
                                        <p className="text-700 font-semibold m-0">Pay & Resume</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="text-center mt-4">
                                <p className="text-lg text-700 mb-0">
                                    <i className="pi pi-info-circle text-blue-500 mr-2"></i>
                                    Service resumes immediately when dues are cleared
                                </p>
                            </div>
                        </div>
                    </Card>

                    {/* Section 4: Refund Timeline */}
                    <Card className="mb-4 shadow-2 border-round-xl">
                        <div className="flex align-items-center mb-4">
                            <div className="bg-cyan-50 p-3 border-round-xl mr-3">
                                <i className="pi pi-clock text-cyan-500 text-2xl"></i>
                            </div>
                            <h2 className="text-3xl font-bold text-900 m-0">4. Refund Timeline</h2>
                        </div>
                        
                        <div className="grid">
                            <div className="col-12 lg:col-4">
                                <Card className="surface-50 h-full text-center">
                                    <div className="bg-blue-100 inline-flex align-items-center justify-content-center border-circle mb-3" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-arrow-left text-blue-600 text-3xl"></i>
                                    </div>
                                    <h4 className="font-bold mb-2">Original Method</h4>
                                    <p className="text-700 m-0">
                                        Eligible refunds processed to original payment method
                                    </p>
                                </Card>
                            </div>
                            
                            <div className="col-12 lg:col-4">
                                <Card className="surface-50 h-full text-center">
                                    <div className="bg-green-100 inline-flex align-items-center justify-content-center border-circle mb-3" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-calendar-plus text-green-600 text-3xl"></i>
                                    </div>
                                    <h4 className="font-bold mb-2">5-7 Working Days</h4>
                                    <p className="text-700 m-0">
                                        "Within five to seven working days"
                                    </p>
                                </Card>
                            </div>
                            
                            <div className="col-12 lg:col-4">
                                <Card className="surface-50 h-full text-center">
                                    <div className="bg-purple-100 inline-flex align-items-center justify-content-center border-circle mb-3" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-bolt text-purple-600 text-3xl"></i>
                                    </div>
                                    <h4 className="font-bold mb-2">Instant Option</h4>
                                    <p className="text-700 m-0">
                                        Instant refunds for compatible cards
                                    </p>
                                </Card>
                            </div>
                        </div>
                    </Card>

                    {/* Section 5: Contact for Refunds */}
                    <Card className="shadow-2 border-round-xl" style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                    }}>
                        <div className="text-white">
                            <div className="text-center mb-5">
                                <i className="pi pi-headphones text-6xl mb-4 opacity-90"></i>
                                <h2 className="text-3xl font-bold mb-3">5. Contact for Refund Requests</h2>
                                <p className="text-lg opacity-95">
                                    Need to request a refund? We're here to help!
                                </p>
                            </div>
                            
                            <div className="grid">
                                <div className="col-12 md:col-6">
                                    <div className="bg-white-alpha-10 border-round-lg p-4 h-full">
                                        <h4 className="font-bold mb-3">
                                            <i className="pi pi-phone mr-2"></i>
                                            Get in Touch
                                        </h4>
                                        <div className="mb-2">
                                            <i className="pi pi-envelope mr-2 opacity-80"></i>
                                            <span className="font-semibold">tech@interestng.com</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 md:col-6">
                                    <div className="bg-yellow-500 bg-opacity-20 border-round-lg p-4 h-full border-2 border-yellow-400">
                                        <h4 className="font-bold mb-3">
                                            <i className="pi pi-exclamation-triangle mr-2"></i>
                                            Important Deadline
                                        </h4>
                                        <p className="text-lg font-semibold m-0">
                                            Refund requests must be submitted within 24 hours of transaction
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="text-center mt-5">
                                <Button 
                                    label="Contact Support" 
                                    icon="pi pi-envelope" 
                                    className="p-button-rounded p-button-lg bg-white text-primary-500 border-none font-bold px-5"
                                    onClick={() => window.location.href = '/app/contact'}
                                />
                            </div>
                        </div>
                    </Card>

                    {/* Additional Information */}
                    <Card className="mt-4 shadow-2 border-round-xl">
                        <div className="text-center mb-4">
                            <i className="pi pi-info-circle text-4xl text-primary mb-3"></i>
                            <h3 className="text-2xl font-bold text-900">Additional Information</h3>
                        </div>
                        
                        <div className="grid">
                            <div className="col-12 md:col-4">
                                <div className="text-center p-3">
                                    <i className="pi pi-shield text-3xl text-green-500 mb-2"></i>
                                    <h4 className="font-bold mb-2">Secure Process</h4>
                                    <p className="text-700 m-0">All refunds are processed securely through Razorpay</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="text-center p-3">
                                    <i className="pi pi-history text-3xl text-blue-500 mb-2"></i>
                                    <h4 className="font-bold mb-2">Transaction History</h4>
                                    <p className="text-700 m-0">View all transactions in your billing portal</p>
                                </div>
                            </div>
                            <div className="col-12 md:col-4">
                                <div className="text-center p-3">
                                    <i className="pi pi-question-circle text-3xl text-purple-500 mb-2"></i>
                                    <h4 className="font-bold mb-2">Need Help?</h4>
                                    <p className="text-700 m-0">Our support team is available Mon-Sat, 9AM-7PM IST</p>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicyContent;